import React from "react";
import { Transaction } from "@common/types/transaction";
import { EagerLoaded } from "@common/types/base/orm";
import { FinancialDocumentSelect } from "@components/documents/FinancialDocumentSelect/FinancialDocumentSelect";
import { DocumentSelectVariant } from "@components/documents/FinancialDocumentSelect/financialDocumentSelectViewConfig";
import { SimplifiedTransactionDetails } from "./SimplifiedTransactionDetails";
import { TransactionMatchingAttachCta } from "./TransactionMatchingAttachCta";

interface Props {
    transaction: EagerLoaded<Transaction, "transactionMatches">;
}

export const TransactionMatchingContainer: React.FC<Props> = ({
    transaction,
}) => (
    <FinancialDocumentSelect
        variant={DocumentSelectVariant.TRANSACTION_MATCHING}
        sidebar={<SimplifiedTransactionDetails transaction={transaction} />}
        cta={(financialDocument) => (
            <TransactionMatchingAttachCta
                financialTransaction={transaction}
                financialDocument={financialDocument}
            />
        )}
    />
);
